const getSearchParams = (location) => {
    return new URLSearchParams(location.search || '')
}

export default getSearchParams
